import React from "react";
import MxTypography from "../../../MxTypography";
import { EFontFamilies } from "@/shared/theme/theme";
interface MxCPropertyTitleProps {
  children: any;
}
const MxCPropertyTitle = (props: MxCPropertyTitleProps) => {
  return (
    <MxTypography
      variant="caption"
      color="primary.main"
      fontWeight={600}
      lines={2}
      fontFamily={EFontFamilies.DEFAULT_FONT}
    >
      {props.children}
    </MxTypography>
  );
};

export default MxCPropertyTitle;
